// extracted by mini-css-extract-plugin
module.exports = {"WorkPage":"Work-module--WorkPage--or7Kf"};